import { Component, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { CustomerEffortScoreService } from '@features/opportunities/services/customerEffortScore.service';

@Component({
  selector: 'spark-ces-survey',
  templateUrl: './customerEffortScore.component.html',
  styleUrls: ['./customerEffortScore.component.scss']
})
export class CustomerEffortScoreComponent implements OnDestroy {
  @Input() opportunityId!: string;
  private submit!: Subscription;
  selectedRating: number | null = null;

  labels = [
    'Very Difficult',
    'Difficult',
    'Easy',
    'Very Easy'
  ];

  constructor(private customerEffortScoreService: CustomerEffortScoreService) {}

  select(rating: number) {
    this.selectedRating = rating;
    this.submit = this.customerEffortScoreService
      .submitCesSurvey(this.opportunityId, rating)
      .subscribe();
  }

  ngOnDestroy() {
    this.submit?.unsubscribe();
  }
}
